import React, { useEffect, useState } from 'react';
import '../../App.css';
import start from "../../assets/images//StartButtonBig.png";
import easy from "../../assets/images//EasyButton.png";
import moderate from "../../assets/images//ModerateButton.png";
import difficult from "../../assets/images//DifficultButton.png";
import Container from '@material-ui/core/Container';
import { Button, List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Copyright from '../common/copyright';
// import headerImage from "../../assets/images/registrationHeader.png";
// import { Image } from '@material-ui/icons';
import { Link, Route, Switch, useLocation, Redirect } from 'react-router-dom';
import TestWithQuestion from '../testWithQuestion/TestWithQuestion';
import Typography from '@material-ui/core/Typography';
import Header from "../common/header";


const TestInstructions = () => {

    // state = {}
    // render() {

    const location = useLocation();
    const [data, setData] = useState('')
    const [assessmentDetails, setAssessmentDetails] = useState('')
    const [instructions, setInstructions] = useState([])
    const [studentDetails, setStudentDetails] = useState('')

    useEffect(() => {
        console.log("useEffect", location);
        if (location.state !== undefined) {
            console.log(location.state); // result: '/secondpage'
            // console.log(location.search); // result: '?query=abc'
            console.log(location.state);
            setData(location.state.data, location.state.doNotSaveFlag)
            setStudentDetails(location.state.studentDetails)
            setAssessmentDetails(location.state.assessmentDetails)
            setInstructions(location.state.assessmentDetails.instructions)
            // result: 'some_value'
        }
    }, [location]);

    const classes = useStyles();
    console.log("data in instruction", data.assessmentDetails);
    console.log(location);
    console.log(location.state);
    var studentName = ""
    var stateName = ""
    if(location.state != undefined && location.state.data.studentDetails != undefined){
        studentName = location.state.data.studentDetails.name
        stateName = location.state.data.studentDetails.stateName
        
    }
    // studentDetails.name ? studentDetails.name:""
    return (
        <Route
            {...location.state}
            render={item =>
                (location.state !== undefined) ? (
                    <div className={classes.root}>
                        <Header
                            name={studentName}
                            className={assessmentDetails.className}
                            location={stateName}
                        />
                        <Container className="App">
                            <Switch>
                                <Route path="/test" component={TestWithQuestion} />
                            </Switch>
                            <div className={classes.topContainer}>
                                <p className={classes.title}>{assessmentDetails.name}</p>
                                <Link to={
                                    {
                                        pathname: "/test",
                                        state: data
                                    }
                                }>
                                    <Button
                                        type="submit"
                                        variant="text"
                                        color="primary"
                                        className={classes.submit}
                                    // onFocusVisible={false}
                                    // onClick
                                    >
                                        <img className='Start' src={start} alt="start" />
                                    </Button>
                                </Link>

                            </div>
                            <div>
                                <div className="levelContainer">
                                    <img className="level" src={easy} alt="start" />
                                    <p>Easy</p>
                                </div>
                                <div className="levelContainer">
                                    <img className="level" src={moderate} alt="start" />
                                    <p>Moderate</p>
                                </div>
                                <div className="levelContainer">
                                    <img className="level" src={difficult} alt="start" />
                                    <p>Difficult</p>
                                </div>
                            </div>
                            <div>
                                <div className="instructionContainer">
                                </div>
                                <div className="instructionContainer">
                                    {/* <img className="level" src={moderate} alt="start" /> */}
                                    <Typography align="left" variant="body1"><b>Instructions:</b></Typography>
                                </div>
                                <div className="instructionContainer">
                                </div>
                            </div>
                            <div>
                                <List dense className={classes.list}>
                                    {instructions.map((value) => {
                                        return (
                                            <ListItem key={value} button className={classes.listItem}>
                                                <ListItemText primary={`• ${value}`} />

                                            </ListItem>
                                        );
                                    })}
                                </List>

                            </div>
                        </Container>
                        <footer className={classes.footer}>
                            <Container maxWidth="sm">
                                <Copyright />
                            </Container>
                        </footer>
                    </div>
                )
                    :
                    (
                        <Redirect to={{ pathname: '/' }} />
                    )
            }
        />
    );





}

export default TestInstructions;


const useStyles = makeStyles((theme) => ({

    topContainer: {
        display: 'flex',
        flexDirection: 'column',
        //marginTop: '25px'
    },
    title: {
        color: '#29A7DF',
        display: 'block',
        fontSize: 30,
        marginBottom: '10px'
    },
    start: {
        alignSelf: 'center',
        height: 6,
        marginTop: 10
        //         align-self: center;
        //   height: 8vh;
        //   margin-top: 10;
        // height: 8vh;
        // margin-top: 10;
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        // backgroundImage: `url(${headerImage})`,
        // backgroundSize: 'cover',
        // alignItems: 'center',
        // backgroundPositionY: '-150px',
        // backgroundRepeat: 'no-repeat',
        // backgroundSize: 'auto',
        // backgroundColor: "#fff",

    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        // backgroundImage: `url(${start})`,
        // backgroundRepeat
        // flex: 1,
        // height: 40
    },
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
        // backgroundColor:
        //     theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
    },

    listItem: {
        textAlign: 'justify'
    }

}));

